<script setup lang="ts">
import type {CheckboxValueType} from 'element-plus';

interface Props {
  isGroup?: boolean;
  label?: string;
  value?: CheckboxValueType;
  disabled?: boolean;
  bold?: boolean;
  type?: string;
  elementClass?: string;
}

export interface  Emits {
  change: [value: CheckboxValueType]
}

//#region props
const props = withDefaults(defineProps<Props>(), {
  isGroup: false,
  value: '',
  elementClass: '',
  disabled: false,
  bold: false,
});
//#endregion


const emit = defineEmits<Emits>();

const modelValue = defineModel<CheckboxValueType>();

function handleChange(val: CheckboxValueType) {
  emit('change', val);
}
</script>

<template>
  <div
    class="ui-checkbox"
    :class="[
      {'ui-checkbox__checkbox_bold': bold},
    ]"
  >
    <template v-if="isGroup">
      <ElCheckbox
        :label="label"
        :value="value"
        class="ui-checkbox__checkbox"
        :class="[
          {[`ui-checkbox__checkbox_${type}`]: type},
        ]"
        @change="handleChange"
      />
    </template>
    <template v-else>
      <ElCheckbox
        v-model="modelValue"
        :value="value !== '' ? value : undefined"
        :label="label"
        :disabled="disabled"
        class="ui-checkbox__checkbox"
        :class="[
          {[`ui-checkbox__checkbox_${type}`]: type},
          elementClass
        ]"
        @change="handleChange"
      />
    </template>
  </div>
</template>

<style lang="scss">
.ui-checkbox {
  display: flex;
  align-items: center;
  &__checkbox {
    --el-checkbox-checked-text-color: var(--text-body);
    --el-checkbox-text-color: var(--text-body);
    --el-checkbox-checked-bg-color: var(--background-primary);
    --el-checkbox-input-border-color-hover: var(--background-primary);
    --el-checkbox-checked-input-border-color: var(--background-primary);
    --el-checkbox-input-border: 1px solid var(--border-default);
    --el-checkbox-disabled-checked-input-fill: var(--background-disabled);
    --el-checkbox-disabled-checked-input-border-color: var(--border-default);
    --el-checkbox-disabled-checked-icon-color: var(--text-body-secondary);
    --el-disabled-text-color: var(--text-body);

    --el-checkbox-font-size: 13px;
    --el-checkbox-input-height: 16px;
    --el-checkbox-input-width: 16px;
    --el-font-weight-primary: 400;
    --el-checkbox-border-radius: 4px;

   // height: var(--el-checkbox-input-height);
    height: auto;

    .el-checkbox__label{
      padding-left: 4px;
    }
    &_bold {
      .el-checkbox__label {
        font-weight: 500;
      }
    }

    &_negative {
      --el-checkbox-input-border-color-hover: var(--background-negative);
      --el-checkbox-checked-input-border-color: var(--background-negative);
      --el-checkbox-checked-bg-color: var(--background-negative);
    }
  }
}
</style>
